export default "__VITE_ASSET__Be0CM5TP__"